import { render, staticRenderFns } from "./tabsComponent.vue?vue&type=template&id=34ac80ef&"
import script from "./tabsComponent.vue?vue&type=script&lang=js&"
export * from "./tabsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports